import { Outlet } from 'react-router'
import useHelmet from '../../utilities/hooks/helmet/useHelmet'

// بازپخش گردش صندوق fills the whole viewport with its own night stage
// (the page renders a position:fixed wrapper), so this layout is only the
// helmet + a dark backdrop behind route transitions.
const FlowReplayLayout = ({ helmet }: { helmet: string }) => {
    useHelmet(helmet)
    return (
        <div className="min-h-screen bg-[#0B0F1E]">
            <Outlet />
        </div>
    )
}

export default FlowReplayLayout
